<template>
  <span v-show="isShowPage">
    <v-row>
      <v-col v-for="(item, idx) in cardItems" :key="idx" cols="12" md="4" lg="4">
        <v-card :color="colorPicker(item.title)" class="card-dashboard2" :loading="isFetching2">
          <template slot="progress">
            <v-progress-linear
              color="primary"
              height="2"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-text>
            <span class="card-dashboard-title2">
              {{ capitalize(item.title) }}
            </span>
            <span style="float: right">
              <span class="card-dashboard-value2">
                {{ item.value }}
              </span>
              <span class="card-dashboard-unit2">nozzle</span>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <l-map
        ref="map"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 600px; margin-top:20px; z-index: 221"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />
        <l-marker
          v-for="(marker, idx) in locationMarkerList"
          :key="idx"
          :options="{ opacity: 1.0, riseOnHover: true }"
          ref="markers"
          :lat-lng="marker.position"
        >
          <l-tooltip :options="{ permanent: true, interactive: true, direction: getLineDirection(marker.lineDirection), opacity: 1, keepInView: true }">
            <span class="marker-detail-title2">{{ capitalize(marker.location_name) }}</span><br/>
            <span style="color: #9BD168;font-weight:500;">Available : {{ marker.available }}</span>
            <span> | </span>
            <span style="color: #60CCDB;font-weight:500;">In Use : {{ marker.inUse }}</span>
            <span> | </span>
            <span style="color: #F26776;font-weight:500;">Unavailable : {{ marker.unavailable }}</span>
            <!-- <table style="border-spacing: 10px 3px;">
              <tr>
                <td class="marker-detail-status-available" style="color: #9A9A9A;">Available</td>
                <td class="marker-detail-value">{{ marker.available }}</td>
              </tr>
              <tr>
                <td class="marker-detail-status-inuse" style="color: #9A9A9A;">In Use</td>
                <td class="marker-detail-value">{{ marker.inUse }}</td>
              </tr>
              <tr>
                <td class="marker-detail-status-unavailable" style="color: #9A9A9A;">Unavailable</td>
                <td class="marker-detail-value">{{ marker.unavailable }}</td>
              </tr>
            </table> -->
          </l-tooltip>
          <l-icon
            :icon-size="dynamicSize"
            :icon-anchor="dynamicAnchor"
            icon-url="ic_mapsmarker.svg"
          />
        </l-marker>
      </l-map>
    </v-row>
    <hr v-if="showDiagram || showMap" class="line-separator">
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row>
      <v-col class="pt-5">
        <Table :headers="headers" :loading="isFetching" :items="items" @onChangePage="getSpkluACHomeCharging('table')" :defaultSize="12" :showPagination="false">
        </Table>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from 'vue2-leaflet'
import Table from '../../components/Table.vue'
import DashboardService from '@/services/DashboardService'

const dashboardService = DashboardService.build()
export default {
  name: 'SPKLUAC',
  components: {
    Table,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    // LPopup,
    LIcon
  },
  data: () => ({
    cardItems: [
      {
        value: 0,
        status: 1,
        title: 'available',
        order_number: 0
      },
      {
        value: 0,
        status: 2,
        title: 'in_use',
        order_number: 1
      },
      {
        value: 0,
        status: 4,
        title: 'unavailable',
        order_number: 2
      }
    ],
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'namaLokasi', text: 'Nama Lokasi', align: 'left' },
      { value: 'available', text: 'Available', align: 'center' },
      { value: 'inUse', text: 'In Use', align: 'center' },
      { value: 'unavailable', text: 'Unavailable', align: 'center' }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    isFetching2: false, // for cards
    isFetching3: false, // for diagram
    input: {
      filter_by: ''
    },
    chargeBoxList: [],
    locationMarkerList: [],

    // map properties
    arrIdSpkluMobile: ['00087', '00078', '00079'],
    arrDataMaps: [],
    zoom: 13,
    center: latLng(0, 0),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: false,
      boxZoom: false,
      keyboard: false,
      dragging: true
    },
    showMap: false,
    iconSize: 50,
    markerObjects: [],
    diagramItems: [],
    diagramLeft: [],
    diagramRight: [],
    diagramTop: [],
    diagramBottom: [],
    diagramEntrance: {},
    defaultW: 1920,
    defaultH: 1080,
    isShowPage: false,
    showDiagram: true,
    mapObj: {},
    table_title: '',
    timer: ''
  }),
  async created () {
    this.table_title = 'Detail Charger'
    this.isShowPage = true
  },
  computed: {
    dynamicSize () {
      // return [this.iconSize, this.iconSize * 1.15]
      return [70, 50]
    },
    dynamicAnchor () {
      // return [this.iconSize / 2, this.iconSize * 1.15]
      return [35, 50]
    }
  },
  mounted: function () {
    if (this.$route.path === '/dashboard/spklu-ac') {
      this.$nextTick(() => {
        //   this.hideOverlappingTooltips()
        this.map = this.$refs.map.mapObject
        this.mapObj = this.map
        // self.map.on('click', function (e) {
        //   console.log(e)
        // })
        // save marker refs
        // this.markerObjects = this.$refs.markers.map(ref => ref.mapObject)
      })

      // re-get data every 1 minute
      this.timer = setInterval(() => {
        this.resetData()
        this.getSpkluACHomeCharging()
        this.isShowPage = true
      }, 60000)
    }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    '$route.path': {
      handler: function (path) {
        this.resetData()
        this.$nextTick(() => {
          this.mapObj = this.$refs.map.mapObject
        })
        this.getSpkluACHomeCharging()
        this.showDiagram = false
        this.showMap = true
        this.isShowPage = true
      },
      deep: true,
      immediate: true
    },
    'mapObj._zoom': {
      handler: function (value) {
        const tooltipTop = document.getElementsByClassName('leaflet-tooltip-top')
        const tooltipLeft = document.getElementsByClassName('leaflet-tooltip-left')
        const tooltipRight = document.getElementsByClassName('leaflet-tooltip-right')
        const tooltipBottom = document.getElementsByClassName('leaflet-tooltip-bottom')

        if (value < 14) {
          for (let i = 0; i < tooltipTop.length; i++) {
            tooltipTop[i].style.visibility = 'hidden'
          }
          for (let i = 0; i < tooltipLeft.length; i++) {
            tooltipLeft[i].style.visibility = 'hidden'
          }
          for (let i = 0; i < tooltipRight.length; i++) {
            tooltipRight[i].style.visibility = 'hidden'
          }
          for (let i = 0; i < tooltipBottom.length; i++) {
            tooltipBottom[i].style.visibility = 'hidden'
          }
        } else {
          for (let i = 0; i < tooltipTop.length; i++) {
            tooltipTop[i].style.visibility = 'visible'
          }
          for (let i = 0; i < tooltipLeft.length; i++) {
            tooltipLeft[i].style.visibility = 'visible'
          }
          for (let i = 0; i < tooltipRight.length; i++) {
            tooltipRight[i].style.visibility = 'visible'
          }
          for (let i = 0; i < tooltipBottom.length; i++) {
            tooltipBottom[i].style.visibility = 'visible'
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getLineDirection (d) {
      if (d === 'LEFT') {
        return 'left'
      } else if (d === 'RIGHT') {
        return 'right'
      } else if (d === 'TOP') {
        return 'top'
      } else if (d === 'BOTTOM') {
        return 'bottom'
      }
    },
    colorPicker (title) {
      if (title === 'available') {
        return '#9BD168'
      } else if (title === 'in_use') {
        return '#60CCDB'
      } else if (title === 'unavailable') {
        return '#F26776'
      }
    },
    overlap (rect1, rect2) {
      return (!(rect1.right < rect2.left ||
              rect1.left > rect2.right ||
              rect1.bottom < rect2.top ||
              rect1.top > rect2.bottom))
    },
    hideOverlappingTooltips () {
      var rects = []
      var tooltips = document.getElementsByClassName('leaflet-tooltip-right')
      for (var a = 0; a < tooltips.length; a++) {
        tooltips[a].style.visibility = ''
        rects[a] = tooltips[a].getBoundingClientRect()
      }
      for (var i = 0; i < tooltips.length; i++) {
        if (tooltips[i].style.visibility !== 'hidden') {
          for (var j = i + 1; j < tooltips.length; j++) {
            if (this.overlap(rects[i], rects[j])) tooltips[j].style.visibility = 'hidden'
          }
        }
      }
    },
    async getSpkluACHomeCharging (type) {
      this.paging.page = 0
      this.paging.size = 12
      const param = Object.assign({}, this.paging)
      const response = await dashboardService.getSpkluAC(param)
      const { data: { data: { content, totalPages, number, totalElements } } } = response

      // for datatable
      if (type === 'table' || !type) {
        this.isFetching = true
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size: 12,
          page: number + 1,
          totalElements
        })
        this.isFetching = false
      }

      // for cards
      if (type === 'cards' || !type) {
        let totalAvailable = 0
        let totalInUse = 0
        let totalUnavailable = 0
        for (let i = 0; i < content.length; i++) {
          totalAvailable += content[i].available
          totalInUse += content[i].inUse
          totalUnavailable += content[i].unavailable
        }
        this.cardItems = [
          {
            value: totalAvailable,
            status: 1,
            title: 'available',
            order_number: 0
          },
          {
            value: totalInUse,
            status: 2,
            title: 'in_use',
            order_number: 1
          },
          {
            value: totalUnavailable,
            status: 4,
            title: 'unavailable',
            order_number: 2
          }
        ]
      }

      // for maps
      if (type === 'maps' || !type) {
        // this.locationMarkerList = []

        let totalLatitude = 0
        let totalLongitude = 0
        let firstLoad = true
        for (let i = 0; i < content.length; i++) {
          totalLatitude += parseFloat(content[i].latitude)
          totalLongitude += parseFloat(content[i].longitude)

          // set location marker
          const position = latLng(content[i].latitude, content[i].longitude)

          // find existing index
          const idx = this.locationMarkerList.findIndex(x => x.id === content[i].spkluId)
          if (idx === -1) {
            const newmarker = {
              id: content[i].spkluId,
              location_name: content[i].namaLokasi,
              available: content[i].available,
              inUse: content[i].inUse,
              unavailable: content[i].unavailable,
              position: position,
              lineDirection: content[i].lineDirection
            }
            this.locationMarkerList.push(newmarker)
          } else if (idx > -1) {
            firstLoad = false
            this.locationMarkerList[idx].available = content[i].available
            this.locationMarkerList[idx].inUse = content[i].inUse
            this.locationMarkerList[idx].unavailable = content[i].unavailable
          }
        }

        if (firstLoad) {
          // set center maps
          this.center = latLng(totalLatitude / content.length, totalLongitude / content.length)
          if (this.zoom === 13) {
            this.zoom += 1
          } else {
            const self = this
            this.zoom -= 1
            setTimeout(function () {
              self.zoom += 1
            }, 300)
          }
        }
      }
    },
    async resetData () {
      this.cardItems = [
        {
          value: 0,
          status: 1,
          title: 'available',
          order_number: 0
        },
        {
          value: 0,
          status: 2,
          title: 'in_use',
          order_number: 1
        },
        {
          value: 0,
          status: 4,
          title: 'unavailable',
          order_number: 2
        }
      ]
      this.items = {}
    }
  }
}
</script>
<style scoped>
</style>
